export default "__VITE_ASSET__05ca5921__"